import { ReactComponent as ArrowRight } from '@Src/assets/images/ArrowRightSmall.svg';

import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { useTranslation } from '@Src/providers/TranslationProvider';

type StyledContainerProps = {
  ownerState: {
    borderRadius?: string;
    borderWidth?: string;
  };
};
const StyledContainer = styled(Grid)<StyledContainerProps>(
  ({ theme, ownerState }) => ({
    borderColor: theme.palette.secondary.lowContrast,
    borderWidth: ownerState.borderWidth || '1px',
    borderStyle: 'solid',
    borderRadius: ownerState.borderRadius || '8px',
    padding: '12px',
    maxWidth: '226px',
    minWidth: '200px',
  }),
);

const StyledViewAllContainer = styled(StyledContainer)<StyledContainerProps>(
  () => ({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
);

const StyledViewAllText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

const StyledViewAllArrowRight = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginLeft: theme.spacing(0.5),
}));

export type MenuItemCardProps = {
  storeUrl: string;
  borderRadius?: string;
  borderWidth?: string;
};

export const ViewAllCard = ({
  storeUrl,
  borderRadius,
  borderWidth,
}: MenuItemCardProps): JSX.Element => {
  const { translate } = useTranslation();

  return (
    <CardActionArea
      href={storeUrl}
      rel="noopener noreferrer"
      style={{
        height: '100%',
        width: '200px',
        borderRadius,
      }}
    >
      <StyledViewAllContainer ownerState={{ borderRadius, borderWidth }}>
        <StyledViewAllText variant="buttonSmall">
          {translate('View_full_menu')}
        </StyledViewAllText>
        <StyledViewAllArrowRight height={12} width={12} />
      </StyledViewAllContainer>
    </CardActionArea>
  );
};
